import {Component, OnInit} from "@angular/core";
import {Router} from "@angular/router";
import {HttpService} from "../service/http-service";
import {API} from "../config/api-config";
import { DragulaService } from 'ng2-dragula/ng2-dragula';
declare var alertify:any;
@Component({
  templateUrl:'./filmType.html'
})

export class FilmType implements OnInit{

  constructor(
    private router:Router,
    private http:HttpService,
    private dragulaService: DragulaService
  ){
    dragulaService.drop.subscribe((value) => {
      //console.log('drop: ${value[0]}');
      this.onDrop(value.slice(1));
    });
  }

  private data:any=[];
  private postData:any=[];
  ngOnInit(): void {
    this.getData();
  }
  private onDrop(args) {
    let [e, el] = args;
    // do something
    this.getList();
  }


  private getData(){
    this.http.getData(API.filmType)
      .then(res=>{
      this.data=res.data;
        for (let i=0;i<this.data.length;i++){
          this.postData.push({'id':this.data[i].id,'rank':this.data[i].rank});
        }
    });
  }

  //获取排序列表
  private getList(){
    this.postData = [];
    for(let i=1;i<this.data.length+1;i++){
      this.postData.push({'id':this.data[i-1].id,'rank':i});
    }
  }
  private sort():void{
    this.http.postData(API.catetorySort,this.postData).then(res=>{
      let data=res;
      if(data.status.code==0 || data.status.code=='0'){
        alertify.success(data.status.message);
      }else{
        alertify.error(data.status.message);
      }
    })
  }
  private editFilmType(id:number){
    this.router.navigate(['index/filmType',id]);
  }

  private deleteFilmType(id:number):void{
    let _self = this;
    alertify.confirm("删除","確定要刪除嗎？",function () {
      _self.http.deleteData(API.filmType+"/"+id).then(res=>{
        if(res.status.code==0){
          alertify.success(res.status.message);
          _self.getData();
        }else {
          alertify.error(res.status.message);
        }
      })
    },function () {

    })
  }

}



// WEBPACK FOOTER //
// /data/jenkins_data/workspace/NaturallyPlus_WEB_UAT/src/app/film/filmType.component.ts